import { useEffect } from 'react';
import { Mailbox } from 'react-bootstrap-icons';

import { Button, Typography } from 'antd';

import EmptyState from '@/components/shared/EmptyState';
import { notificationApi, useMarkAllAsReadMutation } from '@/services/notifications';
import styled, { css, StyledProp } from '@/styled';

import Item from './Item';
import InfiniteScroll from '../../InfiniteScroll';

const TabUpdates = (props: StyledProp) => {
  const [fetch, { data, isFetching }] = notificationApi.endpoints.getNotifications.useLazyQuery();
  const [markAll, markAllResponse] = useMarkAllAsReadMutation();

  useEffect(() => {
    fetch({ page: 1, size: 100 });
  }, [fetch]);

  const fetchNewPage = () => {
    if (!data?.page || isFetching) return;
    if (data?.page?.page >= data?.total_pages) return;

    fetch({ ...data?.page, page: data?.page?.page + 1 });
  };

  if ((data?.data ?? []).length === 0 && !isFetching) {
    return (
      <div className={props.className}>
        <EmptyState
          className='emptyState'
          icon={<Mailbox size={64} />}
          description=''
          title='Você já leu tudo por aqui.'
        />
      </div>
    );
  }

  return (
    <div className={props.className}>
      <div className='updatesHeader'>
        <Typography.Text>Atualizações nos últimos 30 dias</Typography.Text>
        <Button ghost loading={markAllResponse.isLoading}>
          <Typography.Text onClick={() => markAll()}>Marcar tudo como lido</Typography.Text>
        </Button>
      </div>
      <InfiniteScroll className='list' onReachedEnd={() => fetchNewPage()}>
        {data?.data.map(item => (
          <Item {...item} key={item.id} />
        ))}
      </InfiniteScroll>
    </div>
  );
};

export default styled(TabUpdates)(
  ({ theme }) => css`
    width: 100%;

    .emptyState {
      padding: ${theme.space.pxToRem(40)};
    }

    button {
      padding: 0;
      border: 0;
    }

    .list {
      max-height: 280px;
    }

    .updatesHeader {
      padding: ${theme.space.spacing(3, 6)};
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .ant-typography {
        color: ${theme.colorTextTertiary};
        font-size: ${theme.space.pxToRem(12)};
      }
    }
  `
);
